import { useContext } from "react";
import AuthContext from "../../context/AuthProvider";

const AutoLogoutWarning = () => {
  const { showWarning, setShowWarning, resetTimers } = useContext(AuthContext);

  if (!showWarning) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onMouseMove={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <div className="bg-white p-6 rounded-lg w-[500px] text-center">
        <p className="text-lg font-bold mb-4">
          You will be logged out soon due to inactivity!
        </p>
        <p className="mb-6">Click "Stay Logged In" to continue your session.</p>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={() => {
            setShowWarning(false);
            resetTimers();
          }}
        >
          Stay Logged In
        </button>
      </div>
    </div>
  );
};

export default AutoLogoutWarning;
